import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateTimeFormat'
})

export class DateTimePipe implements PipeTransform {
    transform(value: any): string {
        if (!value) {
            return '';
        }

        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const str = value.toString().trim();

        // Try date-only format first: "dd-MM-yyyy" or "dd/MM/yyyy"
        const dateOnlyMatch = str.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
        if (dateOnlyMatch) {
            const day = dateOnlyMatch[1].padStart(2, '0');
            const monthIndex = parseInt(dateOnlyMatch[2], 10) - 1;
            const year = dateOnlyMatch[3];

            if (monthIndex >= 0 && monthIndex < 12) {
                return `${day} ${months[monthIndex]} ${year}`;
            }
        }

        // Parse "dd-MM-yyyy HH:mm:ss" or "dd/MM/yyyy HH:mm:ss" with optional AM/PM
        const match = str.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})/);
        if (match) {
            const day = match[1].padStart(2, '0');
            const monthIndex = parseInt(match[2], 10) - 1;
            const year = match[3];
            let hours = parseInt(match[4], 10);

            if (monthIndex >= 0 && monthIndex < 12) {
                // Convert 24-hour to 12-hour format
                const period = hours >= 12 ? 'PM' : 'AM';
                const hours12 = hours % 12 || 12;
                const hh = hours12.toString().padStart(2, '0');

                return `${day} ${months[monthIndex]} ${year} ${hh}:${match[5]}:${match[6]} ${period}`;
            }
        }

        // Fallback: try new Date() for other formats (ISO, etc.)
        const date = new Date(str);
        if (!isNaN(date.getTime())) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            const hours = date.getHours();
            const period = hours >= 12 ? 'PM' : 'AM';
            const hours12 = hours % 12 || 12;
            const hh = hours12.toString().padStart(2, '0');
            const mm = date.getMinutes().toString().padStart(2, '0');
            const ss = date.getSeconds().toString().padStart(2, '0');

            return `${day} ${month} ${year} ${hh}:${mm}:${ss} ${period}`;
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/filters/dateTime.pipe.ts